import { render, staticRenderFns } from "./linkedin-callback.vue?vue&type=template&id=968f6370&"
import script from "./linkedin-callback.vue?vue&type=script&lang=js&"
export * from "./linkedin-callback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports